document.addEventListener('DOMContentLoaded', function () {

  const root = document.querySelector('.cg-caraway-pdp');

  if (!root) return;


  /* -----------------------------------
     MEDIA GALLERY
  ----------------------------------- */

  const thumbnails = root.querySelectorAll('.cg-thumbnail');
  const mediaSlides = root.querySelectorAll('.cg-media-slide');


  function changeMedia(mediaId) {

    if (!mediaId) return;

    mediaSlides.forEach(slide => {
      slide.classList.toggle(
        'is-active',
        slide.dataset.mediaId === String(mediaId)
      );
    });


    thumbnails.forEach(thumb => {
      thumb.classList.toggle(
        'is-active',
        thumb.dataset.targetMedia === String(mediaId)
      );
    });

  }


  thumbnails.forEach(thumb => {

    thumb.addEventListener('click', function () {
      changeMedia(this.dataset.targetMedia);
    });

  });



  /* -----------------------------------
     PRODUCT ELEMENTS
  ----------------------------------- */

  const variantInputs = root.querySelectorAll(
    '.cg-variant-card input[type="radio"]'
  );

  const price = root.querySelector('[data-current-price]');
  const comparePrice = root.querySelector('[data-compare-price]');
  const saveBadge = root.querySelector('[data-save-badge]');
  const selectedVariant = root.querySelector('[data-selected-variant]');

  const atcPrice = root.querySelector('[data-atc-price]');
  const stickyPrice = root.querySelector('[data-sticky-price]');



  /* -----------------------------------
     QUANTITY
  ----------------------------------- */

  const quantityInput = root.querySelector('[data-quantity]');
  const minus = root.querySelector('[data-qty-minus]');
  const plus = root.querySelector('[data-qty-plus]');



  /* -----------------------------------
     BUNDLE & SAVE
  ----------------------------------- */

  const bundleCards = root.querySelectorAll(
    '[data-bundle-card]'
  );

  const bundleInputs = root.querySelectorAll(
    'input[name="cg_bundle"]'
  );

  const bundlePrices = root.querySelectorAll(
    '[data-bundle-price]'
  );

  const bundleOriginalPrices = root.querySelectorAll(
    '[data-bundle-original]'
  );



  /* -----------------------------------
     24-HOUR FLASH SALE — SHARED TIMESTAMP
     All customers receive the same start/end time from Liquid.
     Existing tier amounts return automatically after 24 hours.
  ----------------------------------- */

  const flashSaleEligible = root.dataset.flashSaleEligible === 'true';
  const flashSaleStartMs = Number(root.dataset.flashSaleStart || 0) * 1000;
  const flashSaleEndMs = Number(root.dataset.flashSaleEnd || 0) * 1000;
  const flashSaleBanner = root.querySelector('[data-flash-sale-banner]');
  const compactFlashBadge = root.querySelector('[data-flash-compact-badge]');

  function isFlashSaleLive() {
    const now = Date.now();
    return flashSaleEligible &&
      flashSaleStartMs > 0 &&
      flashSaleEndMs > flashSaleStartMs &&
      now >= flashSaleStartMs &&
      now < flashSaleEndMs;
  }

  function isFlashSaleActive() {
    return isFlashSaleLive();
  }

  function updateFlashSaleCountdown() {
    const live = isFlashSaleLive();
    const remainingSeconds = live
      ? Math.max(0, Math.ceil((flashSaleEndMs - Date.now()) / 1000))
      : 0;
    const hours = Math.floor(remainingSeconds / 3600);
    const minutes = Math.floor((remainingSeconds % 3600) / 60);
    const seconds = remainingSeconds % 60;
    const pad = value => String(value).padStart(2, '0');

    // Both timers stay hidden everywhere, including theme editor, until
    // 6:00 PM BST (GMT+1) on Oct 17, 2026; disappear at the 24-hour end.
    if (flashSaleBanner) {
      flashSaleBanner.hidden = !live;
    }
    if (compactFlashBadge) {
      compactFlashBadge.hidden = !live;
    }

    if (!live) return;

    if (flashSaleBanner) {
      const hh = flashSaleBanner.querySelector('[data-flash-hours]');
      const mm = flashSaleBanner.querySelector('[data-flash-minutes]');
      const ss = flashSaleBanner.querySelector('[data-flash-seconds]');
      if (hh) hh.textContent = pad(hours);
      if (mm) mm.textContent = pad(minutes);
      if (ss) ss.textContent = pad(seconds);
    }

    if (compactFlashBadge) {
      const hh = compactFlashBadge.querySelector('[data-flash-compact-hours]');
      const mm = compactFlashBadge.querySelector('[data-flash-compact-minutes]');
      const ss = compactFlashBadge.querySelector('[data-flash-compact-seconds]');
      if (hh) hh.textContent = pad(hours);
      if (mm) mm.textContent = pad(minutes);
      if (ss) ss.textContent = pad(seconds);
    }
  }

  /* -----------------------------------
     NORMAL / FLASH BUNDLE DISCOUNTS
     Normal: 7% / 12% / 20%
     Flash: 10% / 15% / 25%
  ----------------------------------- */

  function getBundleDiscount(quantity) {
    // Never show/compute bundle discounts on non-eligible products.
    if (!flashSaleEligible) return 0;
    const flash = isFlashSaleActive();
    quantity = Number(quantity || 1);
    if (quantity === 1) return flash ? 10 : 7;
    if (quantity === 2) return flash ? 15 : 12;
    if (quantity === 3) return flash ? 25 : 20;
    return 0;
  }



  /* -----------------------------------
     MONEY HELPERS
  ----------------------------------- */

  function formatBundleMoney(cents) {

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(cents / 100);

  }


  function moneyTextToCents(text) {

    if (!text) return 0;

    const clean = text
      .replace(/,/g, '')
      .replace(/[^\d.]/g, '');

    const value = parseFloat(clean);

    if (isNaN(value)) return 0;

    return Math.round(value * 100);

  }



  /* -----------------------------------
     CURRENT VARIANT PRICE
  ----------------------------------- */

  function getCurrentVariantPrice() {

    const checkedVariant = root.querySelector(
      '.cg-variant-card input[type="radio"]:checked'
    );


    if (checkedVariant) {

      return Number(
        checkedVariant.dataset.priceCents || 0
      );

    }


    /*
      Fallback for products with
      only one variant.
    */

    if (price) {

      return moneyTextToCents(
        price.textContent
      );

    }


    return 0;

  }



  /* -----------------------------------
     CURRENT BUNDLE
  ----------------------------------- */

  function getSelectedBundle() {

    return root.querySelector(
      'input[name="cg_bundle"]:checked'
    );

  }



  /* -----------------------------------
     MAKE BUNDLE LABELS MATCH
     7% / 12% / 20%
  ----------------------------------- */

  function updateBundleLabels() {

    bundleCards.forEach(card => {

      const input = card.querySelector(
        'input[name="cg_bundle"]'
      );

      if (!input) return;


      const quantity = Number(
        input.dataset.bundleQuantity ||
        input.value ||
        1
      );


      const discount =
        getBundleDiscount(quantity);


      /*
        Keep datasets synced too.
      */

      input.dataset.bundleDiscount =
        String(discount);


      const priceElement =
        card.querySelector(
          '[data-bundle-price]'
        );


      if (priceElement) {

        priceElement.dataset.bundleDiscountValue =
          String(discount);

      }


      /*
        Update subtitle.
      */

      const subtitle =
        card.querySelector(
          '.cg-bundle-subtitle'
        );


      if (subtitle) {

        const oldPercent = subtitle.querySelector('[data-bundle-original-percent]');
        const currentPercent = subtitle.querySelector('[data-bundle-current-percent]');

        if (oldPercent && currentPercent) {
          oldPercent.hidden = !isFlashSaleActive();
          currentPercent.textContent = discount + '%';
        } else {
          subtitle.textContent = 'You save ' + discount + '%';
        }

      }

      // The old crossed-out percentage badge appears ONLY during a flash sale
      // (including its editor-only preview) and hides at the sale's expiry.
      const oldSaveBadge = card.querySelector('[data-bundle-original-save]');
      if (oldSaveBadge) oldSaveBadge.hidden = !isFlashSaleActive();


      /*
        Update or create SAVE badge.
      */

      let titleRow =
        card.querySelector(
          '.cg-bundle-title-row'
        );


      const title =
        card.querySelector(
          '.cg-bundle-title'
        );


      /*
        First bundle may not currently
        have a title row.
      */

      if (!titleRow && title) {

        titleRow =
          document.createElement('div');

        titleRow.className =
          'cg-bundle-title-row';


        title.parentNode.insertBefore(
          titleRow,
          title
        );


        titleRow.appendChild(
          title
        );

      }


      let saveLabel =
        card.querySelector(
          '.cg-bundle-save'
        );


      if (!saveLabel && titleRow) {

        saveLabel =
          document.createElement('span');

        saveLabel.className =
          'cg-bundle-save';

        titleRow.appendChild(
          saveLabel
        );

      }


      if (saveLabel) {

        saveLabel.textContent =
          'SAVE ' +
          discount +
          '%';

      }


      /*
        Make sure every bundle,
        including BUY 1,
        has an original price.
      */

      const priceArea =
        card.querySelector(
          '.cg-bundle-price-area'
        );


      let originalPrice =
        card.querySelector(
          '[data-bundle-original]'
        );


      if (
        !originalPrice &&
        priceArea
      ) {

        originalPrice =
          document.createElement('span');

        originalPrice.className =
          'cg-bundle-original';

        originalPrice.setAttribute(
          'data-bundle-original',
          ''
        );

        originalPrice.dataset.bundleQty =
          String(quantity);


        priceArea.appendChild(
          originalPrice
        );

      }

    });

  }



  /* -----------------------------------
     CALCULATE BUNDLE PRICE
  ----------------------------------- */

  function calculateBundleTotal(
    unitPrice,
    quantity
  ) {

    quantity = Number(
      quantity || 1
    );


    const discount =
      getBundleDiscount(
        quantity
      );


    const normalTotal =
      unitPrice * quantity;


    const discountedTotal =
      Math.round(
        normalTotal *
        (
          1 -
          discount / 100
        )
      );


    return {
      quantity: quantity,
      discount: discount,
      normalTotal: normalTotal,
      discountedTotal: discountedTotal
    };

  }



  /* -----------------------------------
     SELECTED PURCHASE TOTAL
  ----------------------------------- */

  function getSelectedPurchaseTotal(
    unitPrice
  ) {

    if (!unitPrice) {
      return 0;
    }


    const quantity =
      quantityInput
        ? Math.max(
            1,
            Number(
              quantityInput.value || 1
            )
          )
        : 1;


    /*
      Only quantities 1, 2 and 3
      use our bundle discount.
    */

    const result =
      calculateBundleTotal(
        unitPrice,
        quantity
      );


    return result.discountedTotal;

  }



  /* -----------------------------------
     UPDATE ADD TO CART BUTTON PRICE
  ----------------------------------- */

  function updatePurchaseButtonPrice(
    unitPrice
  ) {

    if (!unitPrice) {

      unitPrice =
        getCurrentVariantPrice();

    }


    if (!unitPrice) return;


    const total =
      getSelectedPurchaseTotal(
        unitPrice
      );


    if (atcPrice) {

      atcPrice.textContent =
        formatBundleMoney(
          total
        );

    }


    if (stickyPrice) {

      stickyPrice.textContent =
        formatBundleMoney(
          total
        );

    }

  }



  /* -----------------------------------
     UPDATE ALL BUNDLE PRICES
  ----------------------------------- */

  function updateBundlePrices(
    unitPrice
  ) {

    if (!unitPrice) {

      unitPrice =
        getCurrentVariantPrice();

    }


    if (!unitPrice) return;


    /*
      Discounted bundle prices.
    */

    bundlePrices.forEach(item => {

      const quantity = Number(
        item.dataset.bundleQty || 1
      );


      const result =
        calculateBundleTotal(
          unitPrice,
          quantity
        );


      item.textContent =
        formatBundleMoney(
          result.discountedTotal
        );

    });


    /*
      Original crossed-out prices.
    */

    root
      .querySelectorAll(
        '[data-bundle-original]'
      )
      .forEach(item => {

        const quantity = Number(
          item.dataset.bundleQty || 1
        );


        const normalTotal =
          unitPrice * quantity;


        item.textContent =
          formatBundleMoney(
            normalTotal
          );

      });


    /*
      Update Add to Cart and sticky price
      based on currently selected bundle.
    */

    updatePurchaseButtonPrice(
      unitPrice
    );

  }



  /* -----------------------------------
     SELECT BUNDLE
  ----------------------------------- */

  function selectBundle(input) {

    if (!input) return;


    bundleCards.forEach(card => {

      card.classList.remove(
        'is-selected'
      );

    });


    const card =
      input.closest(
        '[data-bundle-card]'
      );


    if (card) {

      card.classList.add(
        'is-selected'
      );

    }


    input.checked = true;


    const quantity = Number(
      input.dataset.bundleQuantity ||
      input.value ||
      1
    );


    if (quantityInput) {

      quantityInput.value =
        quantity;

    }


    /*
      Update Add to Cart button
      immediately.
    */

    updatePurchaseButtonPrice(
      getCurrentVariantPrice()
    );

  }



  /* -----------------------------------
     SYNC BUNDLE WITH QUANTITY
  ----------------------------------- */

  function syncBundleWithQuantity() {

    if (!quantityInput) return;


    const quantity = Math.max(
      1,
      Number(
        quantityInput.value || 1
      )
    );


    let matchFound = false;


    bundleInputs.forEach(input => {

      const bundleQuantity = Number(
        input.dataset.bundleQuantity ||
        input.value ||
        1
      );


      const card =
        input.closest(
          '[data-bundle-card]'
        );


      if (
        bundleQuantity === quantity
      ) {

        input.checked = true;

        matchFound = true;


        if (card) {

          card.classList.add(
            'is-selected'
          );

        }

      } else {

        input.checked = false;


        if (card) {

          card.classList.remove(
            'is-selected'
          );

        }

      }

    });


    /*
      Quantity above 3:
      no bundle discount.
    */

    if (!matchFound) {

      bundleCards.forEach(card => {

        card.classList.remove(
          'is-selected'
        );

      });

    }


    updatePurchaseButtonPrice(
      getCurrentVariantPrice()
    );

  }



  /* -----------------------------------
     INITIALIZE BUNDLE LABELS
  ----------------------------------- */

  updateBundleLabels();



  /* -----------------------------------
     BUNDLE CLICK EVENTS
  ----------------------------------- */

  bundleInputs.forEach(input => {

    input.addEventListener(
      'change',
      function () {

        selectBundle(this);

      }
    );

  });



  /* -----------------------------------
     VARIANTS
  ----------------------------------- */

  variantInputs.forEach(input => {

    input.addEventListener(
      'change',
      function () {


        root
          .querySelectorAll(
            '.cg-variant-card'
          )
          .forEach(card => {

            card.classList.remove(
              'is-selected'
            );

          });


        this
          .closest(
            '.cg-variant-card'
          )
          .classList.add(
            'is-selected'
          );


        if (selectedVariant) {

          selectedVariant.textContent =
            this.dataset.title;

        }


        /*
          Main product price remains
          selected variant's normal
          single-item price.
        */

        if (price) {

          price.textContent =
            this.dataset.price;

        }


        const compare = Number(
          this.dataset.compareCents || 0
        );


        const current = Number(
          this.dataset.priceCents || 0
        );


        /*
          Main Shopify compare price.
        */

        if (
          comparePrice &&
          saveBadge &&
          compare > current
        ) {

          comparePrice.style.display =
            '';

          comparePrice.textContent =
            this.dataset.compare;


          const percent =
            Math.round(
              (
                (
                  compare -
                  current
                ) /
                compare
              ) *
              100
            );


          saveBadge.style.display =
            '';

          saveBadge.textContent =
            'SAVE ' +
            percent +
            '%';

        } else {


          if (comparePrice) {

            comparePrice.style.display =
              'none';

          }


          if (saveBadge) {

            saveBadge.style.display =
              'none';

          }

        }


        /*
          Recalculate:
          BUY 1 = 7%
          BUY 2 = 12%
          BUY 3 = 20%
        */

        updateBundlePrices(
          current
        );


        /*
          Variant image.
        */

        if (this.dataset.media) {

          changeMedia(
            this.dataset.media
          );

        }


        /*
          Variant URL.
        */

        const url =
          new URL(
            window.location.href
          );


        url.searchParams.set(
          'variant',
          this.value
        );


        window.history.replaceState(
          {},
          '',
          url.toString()
        );

      }
    );

  });



  /* -----------------------------------
     QUANTITY MINUS
  ----------------------------------- */

  if (
    minus &&
    quantityInput
  ) {

    minus.addEventListener(
      'click',
      function () {

        quantityInput.value =
          Math.max(
            1,
            Number(
              quantityInput.value || 1
            ) - 1
          );


        syncBundleWithQuantity();

      }
    );

  }



  /* -----------------------------------
     QUANTITY PLUS
  ----------------------------------- */

  if (
    plus &&
    quantityInput
  ) {

    plus.addEventListener(
      'click',
      function () {

        quantityInput.value =
          Number(
            quantityInput.value || 1
          ) + 1;


        syncBundleWithQuantity();

      }
    );

  }



  /* -----------------------------------
     MANUAL QUANTITY CHANGE
  ----------------------------------- */

  if (quantityInput) {

    quantityInput.addEventListener(
      'change',
      function () {

        let quantity =
          Number(
            this.value || 1
          );


        if (quantity < 1) {

          quantity = 1;

        }


        this.value =
          quantity;


        syncBundleWithQuantity();

      }
    );

  }



  /* -----------------------------------
     INITIAL BUNDLE PRICES
  ----------------------------------- */

  updateBundlePrices(
    getCurrentVariantPrice()
  );

  // Refresh the countdown and pricing when the sale begins or expires,
  // even when a customer keeps the product page open.
  let flashSaleWasActive = isFlashSaleActive();
  updateFlashSaleCountdown();
  if (flashSaleStartMs > 0 && flashSaleEndMs > flashSaleStartMs) {
    const flashSaleInterval = window.setInterval(function () {
      const activeNow = isFlashSaleActive();
      updateFlashSaleCountdown();
      if (activeNow !== flashSaleWasActive) {
        flashSaleWasActive = activeNow;
        updateBundleLabels();
        updateBundlePrices(getCurrentVariantPrice());
      }
      if (Date.now() >= flashSaleEndMs) {
        window.clearInterval(flashSaleInterval);
      }
    }, 1000);
  }



  /* -----------------------------------
     STICKY BUY BAR
  ----------------------------------- */

  const buybar =
    root.querySelector(
      '[data-buybar]'
    );

  const mainButton =
    root.querySelector(
      '.cg-add-to-cart'
    );

  const stickyButton =
    root.querySelector(
      '[data-sticky-add]'
    );


  /* -----------------------------------
     ADD TO CART — OPEN DAWN CART DRAWER
     (NO CART PAGE OR POP-UP)
  ----------------------------------- */

  const productForm = root.querySelector('.cg-product-form');

  if (productForm) {
    productForm.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (mainButton && (mainButton.disabled || mainButton.dataset.adding === 'true')) return;

      // Use the existing Dawn cart drawer instead of a redirect or notification.
      const cartDrawer = document.querySelector('cart-drawer');
      const showCartError = function (message) {
        let error = productForm.querySelector('[data-cg-cart-error]');
        if (!error) {
          error = document.createElement('p');
          error.setAttribute('data-cg-cart-error', '');
          error.setAttribute('role', 'alert');
          error.style.color = '#b42318';
          mainButton.insertAdjacentElement('afterend', error);
        }
        error.textContent = message;
      };

      if (!cartDrawer || typeof cartDrawer.renderContents !== 'function' ||
          typeof cartDrawer.getSectionsToRender !== 'function') {
        showCartError('Cart drawer is not available. Please select Drawer under Theme settings → Cart.');
        return;
      }

      const previousError = productForm.querySelector('[data-cg-cart-error]');
      if (previousError) previousError.textContent = '';

      const formData = new FormData(productForm);
      formData.set('sections', cartDrawer.getSectionsToRender().map(section => section.id).join(','));
      formData.set('sections_url', window.location.pathname);

      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
      }

      if (mainButton) {
        mainButton.dataset.adding = 'true';
        mainButton.disabled = true;
      }
      if (stickyButton) stickyButton.disabled = true;

      try {
        const cartAddUrl = (window.routes && window.routes.cart_add_url) ||
          ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          showCartError(result.description || result.message || 'Could not add this product to your cart.');
          return;
        }

        // Dawn updates the cart contents and counter, then opens the drawer.
        cartDrawer.renderContents(result);
      } catch (error) {
        console.error('Add to cart failed:', error);
        showCartError('Could not add this product to your cart. Please try again.');
      } finally {
        if (mainButton) {
          mainButton.disabled = false;
          delete mainButton.dataset.adding;
        }
        if (stickyButton) stickyButton.disabled = false;
      }
    });
  }


  function updateStickyBar() {

    if (
      !buybar ||
      !mainButton
    ) return;


    const buttonBox =
      mainButton
        .getBoundingClientRect();


    if (
      buttonBox.bottom < 0
    ) {

      buybar.classList.add(
        'is-visible'
      );

    } else {

      buybar.classList.remove(
        'is-visible'
      );

    }

  }


  window.addEventListener(
    'scroll',
    updateStickyBar,
    {
      passive: true
    }
  );


  updateStickyBar();



  /* -----------------------------------
     STICKY BUTTON
  ----------------------------------- */

  if (
    stickyButton &&
    mainButton
  ) {

    stickyButton.addEventListener(
      'click',
      function () {

        // The sticky button adds the same selected variant and quantity.
        if (!mainButton.disabled) mainButton.click();

      }
    );

  }

});